import script from "./affiliatebindcard.vue?vue&type=script&setup=true&lang=js"
export * from "./affiliatebindcard.vue?vue&type=script&setup=true&lang=js"

import "./affiliatebindcard.vue?vue&type=style&index=0&id=6d81f6ee&lang=scss&scoped=true"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d81f6ee"]])

export default __exports__